
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import { getFormatDate } from "@/common/utils";
import { pageViewUnit } from "@/config";
@Component({
	name: "Msg",
	components: {}
})
export default class Msg extends Vue {
	@Action("policy/getPolicyData") private getPolicyData: any;
	@Action("policy/addPolicyView") private addPolicyView: any;
	pageViewUnit = pageViewUnit;
	pageData: any = {};
	msgId: any = this.$route.query.msgId;
	created() {
		this.addPolicyView(this.msgId);
		this.getData();
	}
	getData() {
		this.getPolicyData(this.msgId).then(({ code, data, msg }: any) => {
			if (code === 0) {
				data.releaseDate = getFormatDate(data.releaseDate);
				// data.year = data.pubDate.slice(0, 4);
				this.pageData = data;
			}
			return data;
		});
	}
}
